import React from "react"
import Navigation from "../Shared/Navigation/Navigation"
import Footer from "../Shared/Footer/Footer"
import ContactArea from "../home/contactArea/ContactArea/ContactArea";
import fuji from "../../assets/images/fuji.jpg"
import usePageMeta from "../../hooks/usePageMeta"


function Contact() {
	usePageMeta({
		title: "お問合せ",
		description: "株式会社エムアイジャパンへのお問合せはこちら。人材紹介・採用支援に関するご相談・ご依頼を承ります。",
		path: "/contact",
	});
	return (
		<>

			<Navigation />

			<div className="title_header">
				<img src={fuji} alt="Snow" style={{ width: "100%", height: "200px" }}></img>
				<div className="centered"> <h1>お問合せ</h1></div>
			</div>

			<ContactArea />


			<Footer />
		</>
	)
}

export default Contact